/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Filter_AnyInputs */

const cs_pipelines_filter_any = /** @type {(inputs: Pipelines_Filter_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jakákoli pipeline`)
};

const en_pipelines_filter_any = /** @type {(inputs: Pipelines_Filter_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any pipeline`)
};

/**
* | output |
* | --- |
* | "Any pipeline" |
*
* @param {Pipelines_Filter_AnyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_filter_any = /** @type {((inputs?: Pipelines_Filter_AnyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Filter_AnyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_filter_any(inputs)
	return cs_pipelines_filter_any(inputs)
});